import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/RoomStatusReport/SearchReport",
    method: "get",
    params
  });
}
export function getColumns(params) {
  return request({
    url: "/RoomStatusReport/GetReportHeader",
    method: "get",
    params
  });
}
